const notificationIconType = {
	all: "fa-sharp fa-solid fa-globe",
	creation: "fa-sharp fa-solid fa-user-plus",
	registration: "fa-sharp fa-solid fa-user-check",
	edit: "fa-sharp fa-solid fa-user-pen",
	employer_chat_support: "fa-sharp fa-solid fa-headset",
	member_chat_support: "fa-sharp fa-solid fa-user-headset",
	blogs: "fa-solid fa-laptop-medical",
	announcements: "fa-sharp fa-solid fa-bullhorn",
	statement_of_understanding: "fa-sharp fa-solid fa-building-shield",
	registration_help: "fa-sharp fa-solid fa-hands-holding-child",
	approval: "fa-sharp fa-solid fa-thumbs-up",
	plan_creation: "fa-sharp fa-solid fa-notes-medical",
	open_enrollment: "fa-solid fa-envelope-open-text",
	enrollment_submission: "fa-solid fa-hand-holding-medical",
	terminate: "fa-solid fa-person-circle-xmark",
	reinstate: "fa-solid fa-person-walking-luggage",
	rehire: "fa-solid fa-person-arrow-up-from-line",
	enroller_action: "fa-sharp fa-solid fa-arrow-up-9-1"
};

export const NOTIFICATION_ICON_TYPE = notificationIconType;
